<template>
    <div>
        <div class="columns">
            <div class="column">
                <e-field>
                    <display-content :content="activityContent.content" />
                </e-field>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <e-field label="Acknowledgment">
                    <e-checkbox v-model="userAccepted" :disabled="acknowledgementDisabled">
                        {{ activityContent.acknowledgment_message }}
                    </e-checkbox>
                </e-field>
            </div>
        </div>

        <div v-if="allow_student_attachments && !completed" class="columns">
            <div class="column">
                <e-field label="File Upload">
                    <edverum-file-upload
                        v-if="!completed"
                        :autosave="false"
                        :attachments="media"
                        @add="onMediaAdd"
                        @delete="onMediaDelete"
                    />
                </e-field>
            </div>
        </div>

        <div v-if="userHasAuthorizedAttempt || (!completed && !readOnly)" class="columns">
            <div class="column">
                <e-button :loading="isLoading" :disabled="disabled" type="is-primary" @click="submit" @keyup="submit">
                    Submit
                </e-button>
            </div>
        </div>
        <Divider />
        <div v-if="!readOnly && canViewSubmissions" class="columns">
            <div class="column">
                <submissions :namespace="namespace" @fetch-submissions="toggleSubmissionLoading">
                    <template #content="{ submission }">
                        <div class="columns">
                            <div class="column">
                                <attachments :media="submission.submittable.media" />
                            </div>
                        </div>
                    </template>
                </submissions>
            </div>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get.js';
import some from 'lodash/some.js';
import { mapState } from 'vuex';
import Attachments from '@/components/activity-types/course-activity-types/activities/Attachments.vue';
import Submissions from '@/components/activity-types/course-activity-types/activities/Submissions.vue';
import DisplayContent from '@/components/editor/DisplayContent.vue';
import EdverumFileUpload from '@/components/file-upload/EdverumFileUpload.vue';
import AttemptAuthorizationMixin from '@/mixins/AttemptAuthorization.mixin.js';
import CourseActivityMixin from '@/mixins/CourseActivity.mixin.js';
import IsLateMixin from '@/mixins/IsLate.mixin.js';

export default {
    name: 'AcknowledgeInformation',

    components: {
        Attachments,
        EdverumFileUpload,
        DisplayContent,
        Submissions,
    },

    mixins: [IsLateMixin, CourseActivityMixin, AttemptAuthorizationMixin],

    data: () => ({
        userAccepted: null,
        media: [],
    }),

    computed: {
        ...mapState('Auth', { authUser: state => state.user }),

        acknowledgementDisabled() {
            if (this.usedAllAttemptAuthorizations) {
                return true;
            }

            return !this.userHasAuthorizedAttempt && (!!this.completed || this.readOnly || !this.hasPermissionToSubmit);
        },

        disabled() {
            if (this.usedAllAttemptAuthorizations) {
                return true;
            }

            return some([!this.userAccepted, this.isLate && !this.canSubmitLate && !this.userHasAuthorizedAttempt]);
        },

        payload() {
            return {
                uuid: this.activity.uuid,
                course_id: this.$route.params.courseId,
                activity_id: this.$route.params.activityId,
                activity_type: this.get('activity_type'),
                activity_submission: {
                    acknowledgment: this.userAccepted,
                    media: this.media,
                },
            };
        },

        allow_student_attachments() {
            return get(this.activity, 'activity_settings.allow_student_attachments', false);
        },
    },

    watch: {
        completed(completed) {
            if (completed) {
                this.userAccepted = true;
            }
        },
    },

    methods: {
        onMediaAdd(files) {
            this.media = files;
        },

        onMediaDelete(index) {
            this.media.splice(index, 1);
        },
    },
};
</script>

<style lang="scss">
.tags {
    margin-bottom: 0;
}
</style>
